export function parseVideoQuizTime(time) {
  if (time == null || time === "") return null;
  if (typeof time === "number" && Number.isFinite(time)) {
    return time >= 0 ? time : null;
  }

  const value = String(time).trim();
  if (!value) return null;

  if (/^\d+(\.\d+)?$/.test(value)) {
    const seconds = Number(value);
    return Number.isFinite(seconds) ? seconds : null;
  }

  const parts = value.split(":").map((part) => Number(part));
  if (parts.length === 0 || parts.some((part) => Number.isNaN(part))) {
    return null;
  }

  if (parts.length === 3) {
    return parts[0] * 3600 + parts[1] * 60 + parts[2];
  }
  if (parts.length === 2) {
    return parts[0] * 60 + parts[1];
  }
  return parts[0];
}

export function parseVideoQuestion(raw) {
  if (!raw) return null;

  try {
    const data = typeof raw === "string" ? JSON.parse(raw) : raw;
    if (!data?.question || !Array.isArray(data.choices) || data.choices.length === 0) {
      return null;
    }
    return data;
  } catch {
    return null;
  }
}
